import { render, staticRenderFns } from "./ScoreData.vue?vue&type=template&id=30b26f44&scoped=true&"
import script from "./ScoreData.vue?vue&type=script&lang=js&"
export * from "./ScoreData.vue?vue&type=script&lang=js&"
import style0 from "./ScoreData.vue?vue&type=style&index=0&id=30b26f44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b26f44",
  null
  
)

component.options.__file = "ScoreData.vue"
export default component.exports